module.exports = __webpack_public_path__ + "static/media/suv.6225731c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/CarType/images/suv.jpg
// module id = 531
// module chunks = 0